import work1 from "../../assets/work1.jpg";
import work2 from "../../assets/work2.jpg";
import work3 from "../../assets/work3.jpg";
import work4 from "../../assets/work4.jpg";
export const projectsData = [
  {
    id: 1,
    image: work1,
    title: "web design",
    category: "web",
    demo:"https://github.com/laibabintatahir"
  },
  {
    id: 3,
    image: work3,
    title: "Brand design",
    category: "design",
    demo:"https://libaslegrace.vercel.app/"
  },
  {
    id: 2,
    image: work2,
    title: "App movil",
    category: "app",
    demo:"https://laundryinfo.vercel.app/"
  },

  {
    id: 4,
    image: work4,
    title: "web development",
    category: "web",
    demo:"https://github.com/laibabintatahir"
  },
];

export const projectsNav = [
  { name: "all" },
  { name: "web" },
  { name: "app" },
  { name: "design" },
];
